import React, { useState } from "react";
import { Card, CardBody, Row, Col, Label, Input, Button, FormGroup } from "reactstrap";

// Go-live parity (2026-09-24): EPO#N1 - legacy EpoNew.vb chkCoC: one click puts the
// standard certificate request at the top of the vendor-visible Purchase Notes.
const COC_TEXT = "PLEASE PROVIDE  C OF C  AND MATERIAL/MANUFACTURER'S CERTIFICATES (if applicable) WITH EVERY SHIPMENT";

export default function Comments({ value, onChange }) {

    const handleChange = (e) => {
        const { name, value: newValue } = e.target;
        onChange({
            ...value,
            [name]: newValue
        });
    };

    const handleClear = () => {
        onChange({ purchaseNotes: "", internalNotes: "" });
    };

    const hasCoc = String(value.purchaseNotes || "").includes(COC_TEXT);
    const toggleCoc = (e) => {
        const rest = String(value.purchaseNotes || "").replace(COC_TEXT, "").trim();
        onChange({
            ...value,
            purchaseNotes: e.target.checked ? (rest ? `${COC_TEXT}\n${rest}` : COC_TEXT) : rest
        });
    };

    return (
        <Card>
            <CardBody>
                <Row className="g-4">
                    <Col lg={12}>
                        <FormGroup check className="mb-2">
                            <Input type="checkbox" id="epoCocNote" checked={hasCoc} onChange={toggleCoc} />
                            <Label check htmlFor="epoCocNote">
                                Request C of C and material / manufacturer's certificates with every shipment
                            </Label>
                        </FormGroup>
                        <Label className="form-label">
                            Purchase Notes: <small className="text-muted">(Visible to Vendor)</small>
                        </Label>
                        <Input
                            type="textarea"
                            name="purchaseNotes"
                            value={value.purchaseNotes}
                            onChange={handleChange}
                            rows="5"
                        />
                    </Col>

                    <Col lg={12}>
                        <Label className="form-label mt-3">
                            Internal Notes: <small className="text-muted">(Not Visible to Vendor)</small>
                        </Label>
                        <Input
                            type="textarea"
                            name="internalNotes"
                            value={value.internalNotes}
                            onChange={handleChange}
                            rows="5"
                        />
                    </Col>

                    <Col lg={12} className="d-flex justify-content-end mt-4">
                        <Button color="secondary" outline onClick={handleClear}>
                            Clear Notes
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}
